const dealFileUrl = (url: string, dealFn: Function | null = null) => {
  return dealFn ? dealFn(url) : url.replace('http:', '');
};

export default dealFileUrl;
